import { Grid, LinearProgress } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import Context from '../../context'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'
import { getReportList } from '../../services/report'
// import ProgressBar from '../../components/ProgressBar';

function Report() {
  const { setUser, setAboutCurrentPage } = useContext(Context)
  const [dataList, setDataList] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.push('/')
    }

    setAboutCurrentPage({
      title: 'Relatório de Vendas'
    })

    const getData = async () => {
      return getReportList()
    }

    getData().then(r => {
      setDataList(r)
      setIsLoading(false)
    })
  }, [])

  return (
    <div className="container-fluid h-100">
      <Grid container xs={12} style={{ padding: 15 }}>
        {isLoading ? (
          <Grid item xs={12} justify="center">
            <LinearProgress marginTop="30px" />
          </Grid>
        ) : (
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th />
                <th>Nome</th>
                <th>CPF</th>
                <th>Email</th>
                <th>Telefone</th>
                <th>Data Cadastro</th>
                <th>Oferta</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dataList.map((item, index) => (
                <tr key={`${item.cpf_cnpj}`}>
                  <td>{index + 1}</td>
                  <td>{item.nome}</td>
                  <td>{item.cpf_cnpj}</td>
                  <td>{item.email}</td>
                  <td>{item.telefone_celular}</td>
                  <td>{item.data_cadastro}</td>
                  <td>{item.nome_oferta}</td>
                  <td>{item.status}</td>
                </tr>
              ))}

              <tr key="last">
                <td />
                <td />
                <td />
                <td />
                <td />
                <td align="right">
                  <b>Total</b>
                </td>
                <td>{dataList.length}</td>
              </tr>
            </tbody>
          </table>
        )}
      </Grid>
    </div>
  )
}

export default Report
